import Component from './Component';
import Container from './Container';

const Necromancer = {
    Component, Container
};

export default Necromancer;
